import { StyledOrderInvoiceBase } from './style';
import { Divider } from '../../../../../ui';
import { Field } from './Field';
import { useIntl } from 'react-intl';
import { Transaction } from '../../../../../interfaces/BackendModels';
import { DeliveryType } from '../../../../../types/DeliveryType';
import { useDeliveryRedirects } from '../../../../../utils/useDeliveryRedirects';

interface OrderInvoiceBaseProps {
  transaction?: Transaction | null;
  order?: any;
}

export const OrderInvoiceBase = ({
  transaction,
  order,
}: OrderInvoiceBaseProps) => {
  const intl = useIntl();
  const DEFAULT_VAT = 21;

  const roundDown2Decimals = (num: number) => Math.floor(num * 100) / 100;

  let farmProductTotalWithVAT = 0.0;
  let totalVAT = 0.0;
  transaction?.items.map((item) => {
    farmProductTotalWithVAT += Number(item.stock_total);
    totalVAT += Math.round(Number(item.stock_total) * item.vat) / 100;
  });

  totalVAT += roundDown2Decimals(
    (Number(transaction?.delivery?.price) * DEFAULT_VAT) / 100
  );

  const deliveryRedirects = useDeliveryRedirects();

  const handleArrangeDelivery = () => {
    const type = transaction?.delivery?.type as DeliveryType | undefined;
    const orderId = transaction?.order_id;

    if (!type || orderId == null) return;

    if (deliveryRedirects[type]) {
      deliveryRedirects[type](orderId);
    }
  };

  const firstColumn = [
    {
      labelKey: 'invoice.client',
      value: transaction?.customer_name ?? order?.customer_name ?? '',
    },
    {
      labelKey: 'invoice.phone',
      value:
        transaction?.customer_phone ??
        transaction?.phone ??
        order?.customer_phone ??
        order?.phone,
    },
    {
      labelKey: 'invoice.email',
      value: transaction?.customer_email ?? order?.customer_email ?? '',
    },
    {
      labelKey: 'invoice.delivery_type',
      value: intl.formatMessage({
        id: `delivery.${transaction?.delivery?.type}`,
      }),
    },
    {
      labelKey: 'invoice.delivery_address',
      value: transaction?.items[0]?.delivery_address ?? '',
    },
  ];

  const secondColumn = [
    {
      labelKey: 'invoice.price',
      value: `€ ${(farmProductTotalWithVAT - totalVAT).toFixed(2)}`,
    },
    { labelKey: 'invoice.pvn', value: `€ ${totalVAT.toFixed(2)}` },
    {
      labelKey: 'invoice.price_with_pvn',
      value: `€ ${farmProductTotalWithVAT.toFixed(2)}`,
    },
    {
      labelKey: 'invoice.delivery',
      value: `€ ${Number(transaction?.delivery?.price ?? '').toFixed(2)}`,
    },
    {
      labelKey: 'invoice.total',
      value: `€ ${Number(transaction?.total_sum ?? '').toFixed(2) ?? ''}`,
    },
  ];

  return (
    <StyledOrderInvoiceBase className="invoice-content">
      <div className="content">
        <div className="invoice-data">
          <div className="first">
            {firstColumn.map((fieldDef) => (
              <Field
                key={fieldDef.labelKey}
                labelKey={fieldDef.labelKey}
                value={fieldDef.value}
              />
            ))}
          </div>
          <div className="second">
            {secondColumn.map((fieldDef) => (
              <Field
                key={fieldDef.labelKey}
                labelKey={fieldDef.labelKey}
                value={fieldDef.value}
              />
            ))}
          </div>
        </div>

        <Divider />

        <div className="footer">
          <div className={'arrange-delivery'} onClick={handleArrangeDelivery}>
            {intl.formatMessage({ id: 'invoice.checkout' })}
          </div>
        </div>
      </div>
    </StyledOrderInvoiceBase>
  );
};
